import api from './api';

const BASE = '/attendance';

const attendanceService = {

  // ── Today's overview stats ─────────────────────────────────────────
  getTodayOverview: async () => {
    const r = await api.get(`${BASE}/today/overview`);
    return r.data;
  },

  // ── Today's student status list ────────────────────────────────────
  getTodayStatus: async (search = '', status = '', tower = '') => {
    const params = {};
    if (search) params.search = search;
    if (status) params.status = status;
    if (tower)  params.tower  = tower;
    const r = await api.get(`${BASE}/today`, { params });
    return r.data || [];
  },

  // ── Biometric punch log for a date ─────────────────────────────────
  getBiometricLog: async (date = null) => {
    const params = date ? { date } : {};
    const r = await api.get(`${BASE}/log`, { params });
    return r.data || [];
  },

  // ── Monthly attendance report / heatmap ────────────────────────────
  getMonthlyReport: async (year = null, month = null) => {
    const params = {};
    if (year)  params.year  = year;
    if (month) params.month = month;
    const r = await api.get(`${BASE}/report`, { params });
    return r.data || [];
  },

  // ── All leave requests ─────────────────────────────────────────────
  getAllLeaves: async (status = '') => {
    const params = status ? { status } : {};
    const r = await api.get(`${BASE}/leave`, { params });
    return r.data || [];
  },

  // ── Leave requests for a specific student ──────────────────────────
  getStudentLeaves: async (studentId) => {
    const r = await api.get(`${BASE}/leave/student/${studentId}`);
    return r.data || [];
  },

  // ── Apply for leave ────────────────────────────────────────────────
  applyLeave: async (payload) => {
    const r = await api.post(`${BASE}/leave`, payload);
    return r.data;
  },

  // ── Approve leave ──────────────────────────────────────────────────
  approveLeave: async (id, remarks = '', reviewedBy = 'Admin') => {
    const r = await api.patch(`${BASE}/leave/${id}/review`, {
      status: 'APPROVED', remarks, reviewedBy,
    });
    return r.data;
  },

  // ── Reject leave ───────────────────────────────────────────────────
  rejectLeave: async (id, remarks = '', reviewedBy = 'Admin') => {
    const r = await api.patch(`${BASE}/leave/${id}/review`, {
      status: 'REJECTED', remarks, reviewedBy,
    });
    return r.data;
  },

  // ── Manual punch (admin override) ──────────────────────────────────
  recordManualPunch: async (studentId, punchType, punchTime = null, remarks = '') => {
    const r = await api.post(`${BASE}/punch/manual`, {
      studentId,
      punchType,  // 'IN' or 'OUT'
      punchTime: punchTime || new Date().toISOString().slice(0, 19),
      remarks,
    });
    return r.data;
  },
};

export default attendanceService;